import { render, staticRenderFns } from "./MarkInquiryAsDone.vue?vue&type=template&id=58eaf8b2&scoped=true"
import script from "./MarkInquiryAsDone.vue?vue&type=script&lang=js"
export * from "./MarkInquiryAsDone.vue?vue&type=script&lang=js"
import style0 from "./MarkInquiryAsDone.vue?vue&type=style&index=0&id=58eaf8b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58eaf8b2",
  null
  
)

export default component.exports